import React from 'react';
import _ from 'lodash';
import * as pages from './pageComponents';
import splitViewManager from '../utilities/splitViewManager';
import urlParamManger from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';
import { isNullOrEmpty } from '../utilities/stringUtil';
import { HEADER_CONSTANTS_PROGRESS } from '../utilities/constants';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { PermissionConsumer } from '../utilities/PermissionContext';

export default class ProgressFuncNavi extends React.Component {
  constructor(props) {
    super(props);

    this.settingPages = Object.keys(pages.setting); //設定系画面
    this.singlePages = _.concat(pages.singlepages, this.settingPages);
    this.pages = _.merge(pages, pages.setting);
    this.naviRef = null;

    this.state = {
      railnavi: SessionStorageService.isOpeningFunctionMenu(), // 開閉状態
      prev_railnavi: SessionStorageService.isOpeningFunctionMenu(),
      page: '', //ページコンポーネント名
      disabled: false,
      urlparam: [],
    };

    /**
     * 分割画面のパラメータ
     *
     */
    urlParamManger.setDelegate(urlparam => {
      if (
        //現在と違うページの場合に更新
        urlparam[this.props.vw - 1] &&
        this.state.page.split(':')[0] !=
          urlparam[this.props.vw - 1].split(':')[0]
      ) {
        this.setState({ page: urlparam[this.props.vw - 1], urlparam });
        this.loadPage(urlparam[this.props.vw - 1]);
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }
    });

    EventManager.addEventListener(EventType.FULL_SCREAN_MODE, fullscrean => {
      this.setState({ railnavi: !fullscrean });
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    });
  }

  componentDidMount() {
    EventManager.addEventListener(EventType.CONFERENCE_MODE, conference => {
      if (conference) {
        this.setState({
          railnavi: false,
          prev_railnavi: this.state.railnavi,
        });
      } else {
        this.setState({
          railnavi: this.state.prev_railnavi,
        });
      }
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    });
  }

  /**
   * サイドメニューの開閉
   * @param {boolean} openingFlag
   */
  naviStatus(openingFlag) {
    this.setState({ railnavi: openingFlag });
    SessionStorageService.setOpeningFunctionMenu(openingFlag);
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
  }

  /**
   * ページのロード
   * @param { string } page
   */
  loadPage(page) {
    // 現在のpageと選択したpageが違えば処理を行う。同じであればreturn
    if (isNullOrEmpty(page) || page === this.state.page.split(':')[0]) {
      return;
    }

    if (
      _.includes(this.state.page, 'Notifications') &&
      _.isNull(sessionStorage.getItem('field_id'))
    ) {
      this.setState({ disabled: true });
    } else {
      this.setState({ disabled: false });
    }

    let pageParams = page.split(':');

    //シングルページの場合 splitViewManagerに通知
    const regexp = new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
    if (pageParams[0].split(':')[0].match(regexp) ? true : false) {
      splitViewManager.forceSingleViewUpdate();
    }

    //設定系画面の場合
    const regexp2 = new RegExp(`^(${this.settingPages.join('|')}).*`, 'g');
    if (pageParams[0].split(':')[0].match(regexp2) ? true : false) {
      EventManager.trigger(EventType.HIDE_MASTER_MENU, {});
    }

    //ページをコンポーネントをロード
    const _settingPage = _.filter(this.settingPages, settingPage => {
      return settingPage == pageParams[0];
    });
    if (_settingPage.length) {
      this.props.loadSettingPage(Number(this.props.vw))(
        this.pages[pageParams[0]],
        pageParams
      );
    } else {
      this.props.loadPage(Number(this.props.vw))(
        this.pages[pageParams[0]],
        pageParams
      );
    }

    /**
     *TODO urlParamManagerを修正すること
     *同じURLが何度もpushstateされないよう、if文を追加して暫定対応中
     */
    if (pageParams.length === 1 && this.state.page !== page) {
      urlParamManger.setPage(page, this.props.vw);
      this.setState({ page });
      setTimeout(() => {
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }, 1);
    }
  }

  // 機能一覧を動作可能状態にする
  enableNavi() {
    if (!this.naviRef) {
      return;
    }
    this.naviRef.style.pointerEvents = 'auto';
    this.naviRef.style.opacity = '1';
    this.naviRef.style.cursor = 'pointer';
  }

  // 機能一覧を動作不可能状態にする
  disableNavi() {
    if (!this.naviRef) {
      return;
    }
    this.naviRef.style.pointerEvents = 'none';
    this.naviRef.style.opacity = '.6';
    this.naviRef.style.cursor = 'inherit';
  }

  render() {
    const railside = classname => {
      return this.state.railnavi ? `${classname} show` : classname;
    };
    let classSchedule;
    let classSelectWork;
    let classSetting;
    if (!_.isEmpty(this.state.urlparam)) {
      const pageName = this.state.urlparam[0].split(':')[0];
      switch (pageName) {
        case 'ProgressSchedule':
          classSchedule = 'select';
          break;
        case 'ProgressScheduleEdit':
          classSchedule = 'select';
          break;
        case 'ProgressChangeOrderOfWorkType':
          classSchedule = 'select';
          break;
        case 'ProgressSelectWorkType':
          classSelectWork = 'select';
          break;
        case 'ProgressSettingLocation':
          classSetting = 'select';
          break;
        case 'ProgressSetting':
          classSetting = 'select';
          break;
      }
    }
    return (
      <PermissionConsumer>
        {({ userHasNyutaiPermission }) => {
          // rails.jsxのPermissionProviderから受け取る
          if (SessionStorageService.getFieldId() && userHasNyutaiPermission) {
            this.enableNavi();
          } else {
            this.disableNavi();
          }
          return (
            <div
              ref={e => {
                this.naviRef = e;
              }}
              id={`func-navi--item${this.props.vw}`}
              className={railside('rail__side')}
            >
              <div className='rail__navi'>
                <div
                  id='func-navi--item1-btn-open'
                  className='btn-rail-navi btn--rail__show'
                  onClick={() => {
                    this.naviStatus(true);
                  }}
                >
                  <i className='i-warrow-right i-2x' alt='開く' aria-hidden='true' />
                </div>
                <div
                  id='func-navi--item1-btn-close'
                  className='btn-rail-navi btn--rail__hide'
                  onClick={() => {
                    this.naviStatus(false);
                  }}
                >
                  <i className='i-warrow-left i-2x' alt='閉じる' aria-hidden='true' />
                </div>
              </div>
              <div className='rail__menu'>
                <div className='func-navi'>
                  <ul className='list list--func-navi'>
                    <h2 className='list__header'>機能一覧</h2>
                    <div className='list__scroll'>
                      <li className='list__item'>
                        <div
                          className={`line-list line-list--list ${classSchedule}`}
                          onClick={() => {
                            this.loadPage('ProgressSchedule');
                          }}
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-home' aria-hidden='true' />
                          </div>
                          {HEADER_CONSTANTS_PROGRESS.progressSchedule}
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={`line-list line-list--list ${classSelectWork}`}
                          onClick={() => {
                            this.loadPage('ProgressSelectWorkType');
                          }}
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-handyman' aria-hidden='true' />
                          </div>
                          {HEADER_CONSTANTS_PROGRESS.progressSelectWork}
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={`line-list line-list--list ${classSetting}`}
                          onClick={() => {
                            this.loadPage('ProgressSetting');
                          }}
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-settei' aria-hidden='true' />
                          </div>
                          {HEADER_CONSTANTS_PROGRESS.progressSetting}
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          );
        }}
      </PermissionConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/progressFuncNavi.js